<ng-content select="[stack-left]"></ng-content>
<ng-content/>
<div class="stack-center"></div>
<ng-content select="[stack-right]"></ng-content>
